export default "__VITE_ASSET__Octa4dRP__"